import React, { useState } from "react";
import BaseModal from "../../../components/ui/BaseModal";
import BaseButton from "../../../components/ui/BaseButton";
import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { showToast } from "../../../store/toast/toastSlice";
import { useParams } from "react-router-dom";
import { useUpdateWorkOrder } from "../../../hooks/useUpdateWorkOrder";
import { updateTask } from "../../../services/api/task";
import { handleGetLocation } from "../../../utils/helpers";
import { checkIn } from "../../../services/api/timeLog";
import dayjs from "dayjs";
import { getTimeZoneAbbreviation } from "../../../utils/getTimeZoneAbbreviation";

const RunningLateModal = ({
  runningLateModalOpen,
  setRunningLateModalOpen,
  tasks,
  refetchUserAllowedAction,
}) => {
  const dispatch = useDispatch();
  const { updateWorkOrder } = useUpdateWorkOrder();
  const [reason, setReason] = useState("");
  const {
    isLoading: isTaskUpdateLoading,
    error: isTaskUpdateError,
    data: updatedTaskData,
    mutateAsync: updateTaskMutation,
  } = useMutation({
    mutationFn: updateTask,
    enabled: false,
  });

  const handleRunningLate = async () => {
    const task = tasks?.find((task) => task.taskType === "RUNNING_LATE");
    try {
      let payload = {
        id: task.completedTask?.id,
        isCompleted: true,
        text: reason,
      };

      const updatedTask = await updateTaskMutation(payload);

      updateWorkOrder();
      refetchUserAllowedAction();
      setRunningLateModalOpen(false);
      setReason("");
    } catch (error) {
      dispatch(
        showToast({
          message: error?.response?.data?.message,
          type: "error",
        })
      );
    }
  };

  const handleRunningLateReason = (e) => {
    setReason(e.target.value);
  };
  return (
    <BaseModal
      open={runningLateModalOpen}
      close={() => {
        setRunningLateModalOpen(false);
      }}
      style={{ width: "600px" }}
    >
      <div className="container">
        <h6 className="text-dark border-bottom mb-4 pb-1">Running Late</h6>
        <p className="bg-primary text-white rounded py-2 px-3">
          Please note that Running late will impact your timeliness on the
          Marketplace.
        </p>

        <div className="flex items-center justify-between mt-4">
          <p className="font-normal">Marked at</p>
          <p>
            {dayjs().format("dddd, MM/D/YYYY")} at {dayjs().format("h:mm A")} (
            {getTimeZoneAbbreviation(
              Intl.DateTimeFormat().resolvedOptions().timeZone
            )}
            )
          </p>
        </div>

        <p className="font-normal mt-6 mb-1">Reason For Late</p>
        <textarea
          // value={message}
          className="bg-[#F5F5F5] w-full rounded-lg h-28 resize-none p-4 text-xs text-zinc-600"
          onChange={(e) => handleRunningLateReason(e)}
        />
      </div>
      <div
        className="flex items-center justify-center bg-white py-6 mt-2"
        style={{
          boxShadow: "5px 0px 14px 5px rgba(0, 0, 0, 0.07)",
        }}
      >
        <BaseButton
          className="py-[5px] px-2 bg-[#E8E8E8] text-dark"
          fullWidth={false}
          onClick={() => setRunningLateModalOpen(false)}
        >
          <p>Cancel</p>
        </BaseButton>
        <BaseButton
          disabled={isTaskUpdateLoading}
          isLoading={isTaskUpdateLoading}
          className="py-[5px] px-4 ml-4"
          color="primary"
          fullWidth={false}
          onClick={handleRunningLate}
        >
          Running Late
        </BaseButton>
      </div>
    </BaseModal>
  );
};

export default RunningLateModal;
